import { motion } from 'framer-motion';
import { BRAND } from '../data/content';

// WhatsApp phone number (primary contact) — digits only, with country code
const WHATSAPP_NUMBER = '919821031222';
const DEFAULT_MSG = encodeURIComponent(
    "Hello Indian Industrial Distributors — I'd like to share my grade / size / quantity requirement and request a catalog."
);

const WhatsAppFab = () => {
    const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_MSG}`;
    return (
        <motion.a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-fab"
            aria-label="Chat on WhatsApp"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ delay: 2.2, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
            className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 group inline-flex items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] text-white shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:bg-[#128C7E] transition-colors"
        >
            <span className="relative flex h-9 w-9 items-center justify-center bg-white/15">
                <span className="absolute inset-0 bg-white/20 animate-ping" />
                <svg viewBox="0 0 32 32" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M19.11 17.32c-.28-.14-1.65-.81-1.9-.9-.25-.09-.44-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.19-.28.28-.46.09-.18.05-.34-.02-.48-.07-.14-.62-1.5-.85-2.05-.22-.53-.45-.46-.62-.47-.16-.01-.34-.01-.53-.01-.18 0-.48.07-.73.34-.25.28-.96.94-.96 2.28 0 1.34.98 2.63 1.12 2.81.14.18 1.94 2.96 4.71 4.14.66.28 1.17.45 1.57.58.66.21 1.25.18 1.72.11.52-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.52-.32zM16 3C8.83 3 3 8.83 3 16c0 2.3.6 4.46 1.65 6.32L3 29l6.86-1.6C11.65 28.48 13.77 29 16 29c7.17 0 13-5.83 13-13S23.17 3 16 3zm0 23.6c-2 0-3.9-.53-5.55-1.44l-.4-.24-4.07.95.98-3.95-.26-.4A10.53 10.53 0 015.4 16C5.4 10.16 10.16 5.4 16 5.4S26.6 10.16 26.6 16 21.84 26.6 16 26.6z" />
                </svg>
            </span>
            <span className="text-[11px] font-mono uppercase tracking-[0.22em] hidden sm:inline">
                Chat · Send spec
            </span>
        </motion.a>
    );
};

export default WhatsAppFab;
